import DashboardShortcutWizardAdminAccessAction from '@/modules/dashboard/shortcuts/components/DashboardShortcutWizardAdminAccessAction.vue';
import DashboardShortcutWizardAdminCreateAction from '@/modules/dashboard/shortcuts/components/DashboardShortcutWizardAdminCreateAction.vue';
import DashboardShortcutWizardBoardAccessAction from '@/modules/dashboard/shortcuts/components/DashboardShortcutWizardBoardAccessAction.vue';
import DashboardShortcutWizardBoardCreateAction from '@/modules/dashboard/shortcuts/components/DashboardShortcutWizardBoardCreateAction.vue';
import DashboardShortcutWizardContentAccessAction from '@/modules/dashboard/shortcuts/components/DashboardShortcutWizardContentAccessAction.vue';
import DashboardShortcutWizardContentCreateAction from '@/modules/dashboard/shortcuts/components/DashboardShortcutWizardContentCreateAction.vue';
import DashboardShortcutWizardTaxonomyAccessAction from '@/modules/dashboard/shortcuts/components/DashboardShortcutWizardTaxonomyAccessAction.vue';
import DashboardShortcutWizardTaxonomyCreateAction from '@/modules/dashboard/shortcuts/components/DashboardShortcutWizardTaxonomyCreateAction.vue';
import DashboardShortcutWizardToolsAccessAction from '@/modules/dashboard/shortcuts/components/DashboardShortcutWizardToolsAccessAction.vue';

export type ShortcutWizardResourceConfig = {
  resource: string;
  label: string;
  actions: ShortcutWizardActions;
};

export type ShortcutWizardAvailableActions = 'create' | 'access';

export type ShortcutWizardActions = {
  [k in ShortcutWizardAvailableActions]?: object;
};

export type ShortcutsWizardConfig = {
  [k: string]: ShortcutWizardResourceConfig,
}

export interface ShortcutBase {
  id: string,
  type: string;
  icon: string;
  text: string;
}
export interface ShortcutLink extends ShortcutBase {
  type: 'dashboard-link-shortcut',
  url: string;
}

export interface ShortcutCreate extends ShortcutBase {
  type: 'dashboard-create-entity-shortcut',
  entity: string;
}

export const config: ShortcutsWizardConfig = {
  boards: {
    resource: 'boards',
    label: 'message.permissions.resources.boards',
    actions: {
      create: DashboardShortcutWizardBoardCreateAction,
      access: DashboardShortcutWizardBoardAccessAction,
    },
  },
  contents: {
    resource: 'contents',
    label: 'message.permissions.resources.contents',
    actions: {
      create: DashboardShortcutWizardContentCreateAction,
      access: DashboardShortcutWizardContentAccessAction,
    },
  },
  taxonomies: {
    resource: 'taxonomies',
    label: 'message.permissions.resources.taxonomies',
    actions: {
      create: DashboardShortcutWizardTaxonomyCreateAction,
      access: DashboardShortcutWizardTaxonomyAccessAction,
    },
  },
  tools: {
    resource: 'tools',
    label: 'message.permissions.resources.tools',
    actions: {
      access: DashboardShortcutWizardToolsAccessAction,
    },
  },
  admin: {
    resource: 'admin',
    label: 'message.permissions.resources.admin',
    actions: {
      create: DashboardShortcutWizardAdminCreateAction,
      access: DashboardShortcutWizardAdminAccessAction,
    },
  },
  site: {
    resource: 'site',
    label: 'message.permissions.resources.sites',
    actions: {},
  },
};

export default {
  config,
};
